export default __webpack_public_path__ + "static/media/Workorders_Active.d82ca142.svg";